import React, { useCallback } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { useEnableNotifications } from '../../api-hooks/notify/notify';
import { useRegisterAndSubscribe } from '../../lib/serviceWorkerHook';
import { ButtonPill, ButtonPillOutline } from '../Button';
import { LOCAL_STORAGE_WEB_PUSH_KEY, useWebPush } from './Provider';

export const WebPushModal = () => {
	const { isOpen, closeModal } = useWebPush();
	const registerAndSubscribe = useRegisterAndSubscribe();
	const { mutate: enableNotifications } = useEnableNotifications();
	const { t } = useTranslation();
	const handleSubmit = useCallback(async () => {
		enableNotifications();
		registerAndSubscribe();
		localStorage.setItem(LOCAL_STORAGE_WEB_PUSH_KEY, 3);
		closeModal();
	}, [closeModal, enableNotifications, registerAndSubscribe]);

	return (
		<Modal
			isOpen={isOpen}
			toggle={closeModal}
			zIndex={1800}
			className="position-absolute mr-3 mb-3 top-0 right-0 text-black"
		>
			<ModalHeader toggle={closeModal}>
				<strong>{t('WebPush.Modal.Header')} </strong>
			</ModalHeader>
			<ModalBody>
				<p>{t('WebPush.Modal.Text')}</p>

				<div className="d-flex justify-content-end">
					<ButtonPill
						className="CookiesApproval_Icon_Button ml-2 mb-1 flex-shrink-0"
						color="primary"
						title="Install"
						onClick={handleSubmit}
					>
						{t('WebPush.Modal.Allow')}
					</ButtonPill>
					<ButtonPillOutline
						className="CookiesApproval_Icon_Button ml-2 mb-1 flex-shrink-0"
						color="secondary"
						title="Cancel"
						onClick={closeModal}
					>
						{t('WebPush.Modal.Close')}
					</ButtonPillOutline>
				</div>

			</ModalBody>
		</Modal>
	);
};
